import { useContext } from 'react';
import { MemberAuthContext } from '../context/MemberAuthContext';

/**
 * Hook para acessar o contexto de autenticação do associado
 */
export const useMemberAuth = () => {
  const context = useContext(MemberAuthContext);

  if (!context) {
    throw new Error('useMemberAuth must be used within a MemberAuthProvider');
  }

  return context;
};
